import React, { useState, useEffect, useContext } from "react";

// Components
import { NavButton } from "../Form/Button";
import AppContext from "../../context";
import SectionHeader from "../Layout/SectionHeader";
import SectionSelector from "../Layout/SectionSelector";
import SectionBody from "../Layout/SectionBody";
import FileUpload from "./FileUpload";
import noLimit from "../../images/quote-no-limit.png";
import config from "../../helpers/config";
import getParameterByName from "../../helpers/getParameterByName";
// import ActionLinks from "../Layout/ActionLinks";

function LandingPage() {
  // State
  const {
    themes,
    setName,
    setEmail,
    myCanvas,
    setError,
    setCurrentPage,
    name,
    email,
    setSaved,
    setSelectedQuote,
    setUuid,
    setInstaNavyImage,
    setInstaRedImage,
    setInstaTealImage,
    setMetaNavyImage,
    setMetaRedImage,
    setMetaTealImage,
  } = useContext(AppContext);

  const [selectionMade, setSelectionMade] = useState(true);
  const [activeButton, setActiveButton] = useState("1");
  const [validEmail, setValidEmail] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    setValidEmail(true);
    myCanvas.setPledge(noLimit);
  }, []);

  const validateEmail = () => {
    let emailValue = document.getElementById("email-input").value;

    let matches = emailValue.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if (matches) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
    return matches;
  };

  const handlePledgeSelection = (event) => {
    myCanvas.setPledge(event.target.value);
    setSelectionMade(true);
    setActiveButton(event.target.name);
    setSelectedQuote(themes.pledges[`alt${event.target.name}`]);
  };

  const moveToNextPage = () => {
    let nameValue = document.getElementById("name-input").value;
    let emailValue = document.getElementById("email-input").value;

    let errMsg = "";
    let missingfields = [];

    if (selectionMade !== true) {
      errMsg = "Please select an option for your pledge graphic. ";
    }

    if (nameValue === "") {
      missingfields.push("your name");
    }

    if (emailValue === "") {
      missingfields.push("your email");
    } else {
      if (!validateEmail()) {
        errMsg += "Please enter in a valid email. ";
        setValidEmail(false);
      }
    }

    if (missingfields.length > 0) {
      errMsg += "Please enter in " + missingfields[0];

      if (missingfields.length === 2) {
        errMsg += " and " + missingfields[1];
      }

      errMsg += ".";
    }

    if (errMsg !== "") {
      setError(errMsg);
    } else {
      setName(nameValue);
      setEmail(emailValue);
      myCanvas.setName(nameValue);
      setError(false);
      saveInformation();
    }
  };

  const saveInformation = async () => {
    try {
      const response = await fetch(config.SAVE_URL, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          name: name,
          code: getParameterByName("code"),
          shareID: getParameterByName("shareID"),
          utm_source: getParameterByName("utm_source"),
          utm_campaign: getParameterByName("utm_campaign"),
          utm_medium: getParameterByName("utm_medium"),
        }),
      });

      const result = await response
        .json()
        .then((resp) => {
          setUuid(resp.uuid);
        })
        .then(async () => {
          await drawAllVariantions();
        })
        .then(() => {
          setSaved(true);
        })
        .catch((err) => {
          console.log(err);
          console.log(`An Error has occurred: ${err.message}`);
        });

      setCurrentPage("output");
    } catch (err) {
      console.log(err);
      console.log(`An Error has occurred: ${err.message}`);
    }
  };

  async function drawInstaCanvas(bg) {
    const returnedImage = await myCanvas.drawInsta(bg);
    if (bg === "red") {
      setInstaRedImage(returnedImage);
    } else if (bg === "teal") {
      setInstaTealImage(returnedImage);
    } else {
      setInstaNavyImage(returnedImage);
    }
  }

  async function drawMetaCanvas(bg) {
    const returnedImage = await myCanvas.drawMeta(bg);
    if (bg === "red") {
      setMetaRedImage(returnedImage);
    } else if (bg === "teal") {
      setMetaTealImage(returnedImage);
    } else {
      setMetaNavyImage(returnedImage);
    }
  }

  const drawAllVariantions = async () => {
    drawMetaCanvas("red");
    drawMetaCanvas("teal");
    drawMetaCanvas("navy");
    drawInstaCanvas("red");
    drawInstaCanvas("teal");
    drawInstaCanvas("navy");
  };

  const updateName = (e) => {
    setName(e.target.value);
  };

  const updateEmail = (e) => {
    validateEmail();
    setEmail(e.target.value);
  };

  return (
    <>
      <div className="body-container">
        <SectionHeader
          className={"blue-hdr"}
          sectionLabel={
            "Commit to showing students that everyone can succeed in math."
          }
        />
        <SectionBody className={"body-text"} />
        <SectionHeader
          className={"blue-hdr"}
          sectionLabel={"Add your name to create your custom graphic!"}
        />
        <div className="email-container">
          <div className="field">
            <label htmlFor="name-input">Name</label>
            <input
              id="name-input"
              value={name}
              onChange={updateName}
              maxLength={20}
            />
          </div>
          <div className="field email-field">
            <label htmlFor="email-input">Email address</label>
            <input
              id="email-input"
              className={validEmail ? "" : "incorrect-field"}
              value={email}
              onChange={updateEmail}
            />
          </div>
        </div>
      </div>
      <div className="blue-section">
        <SectionSelector
          theme={themes.pledges}
          btnOnClick={handlePledgeSelection}
          activeBtnID={activeButton}
        />
        <div className="upload-container">
          <FileUpload />
          <NavButton
            onClick={moveToNextPage}
            btnText="GET MY GRAPHIC &#10132;"
          />
        </div>
      </div>
      {/* <div className="body-container"> */}
      {/* <SectionHeader
          className={"blue-hdr"}
          sectionLabel={
            "Explore tools below to support you in building a culture of positive math mindsets in your school community!"
          }
        /> */}
      {/* <ActionLinks
          link1href={""}
          link2href={""}
          link1Copy={
            <>
              <b>
                TOOLKIT FOR TALKING ABOUT BUILDING A POSITIVE MATH MINDSET
                CULTURE WITH YOUR COLLEAGUES.
              </b>
            </>
          }
          link2Copy={
            <>
              <b>
                [VIDEO!] WHAT HAPPENS WHEN STUDENTS DON'T BELIEVE IN THEIR OWN
                POTENTIAL?
              </b>
            </>
          }
        />
      </div> */}
    </>
  );
}

export default LandingPage;
